<template>
  <div>
    <div id="occupation-distribution" style="height: 400px; width: 488px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: ["#5470C6", "#EE6666", "#FAC858", "#91CC75"],
      data: [],
      num: 0,
      testData: [
        { label: "可乐", amount: 1000 },
        { label: "雪碧", amount: 700 },
        { label: "土豆", amount: 300 },
        { label: "饼干", amount: 500 },
      ],
    };
  },
  props: ["userData"],
  watch: {
    userData: function (newVal, oldVal) {
      for( let key in this.userData.occupation_result){
        this.data.push({ label: key, amount: this.userData.occupation_result[key] });
        this.num += this.userData.occupation_result[key]
      }
    
      this.initBubbleChart(this.data, ["label", "amount"], "bubble");
    },
  },
  methods: {
  
    initBubbleChart(data = [], format = [], dom) {
      let [maxValue, temp] = [0, []];
      data.forEach((item) => {
        temp.push(item[format[1]]);
      });
      maxValue = Math.max.apply(null, temp);

      // 气泡颜色数组
      let color = ["#5470C6", "#EE6666", "#FAC858", "#91CC75"];
      // 气泡颜色备份
      let bakeColor = [...color];
      // 气泡数据
      let bubbleData = [];
      // 气泡基础大小
      let basicSize = 70;
      // 节点之间的斥力因子,值越大,气泡间距越大
      let repulsion = 150;
      // 根据气泡数量配置基础大小和斥力因子（以实际情况进行适当调整，使气泡合理分布）
      if (data.length >= 5 && data.length < 10) {
        basicSize = 50;
        repulsion = 80;
      }
      if (data.length >= 10 && data.length < 20) {
        basicSize = 40;
        repulsion = 100;
      } else if (data.length >= 20) {
        basicSize = 30;
        repulsion = 205;
      }

      // 填充气泡数据数组bubbleData
      for (let item of data) {
        // 确保气泡数据条数少于或等于气泡颜色数组大小时，气泡颜色不重复
        if (!bakeColor.length) bakeColor = [...color];
        let colorSet = new Set(bakeColor);
        let curIndex = Math.round(Math.random() * (colorSet.size - 1));
        let curColor = bakeColor[curIndex];
        colorSet.delete(curColor);
        bakeColor = [...colorSet];
        // 气泡大小设置
        let size = (item[format[1]] * basicSize * 2) / maxValue;
        if (size < basicSize) size = basicSize;

        bubbleData.push({
          name: item[format[0]],
          value: item[format[1]],
          symbolSize: size*1.2,
          draggable: true,
          itemStyle: {
            normal: { color: curColor },
          },
        });
      }
      let that =this
      let bubbleId = document.getElementById("occupation-distribution");
      let bubbleChart = this.$echarts.init(bubbleId);
      let bubbleOptions = {
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          function (param) {
            return param.name + " " + param.value;
          },
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
    
        // backgroundColor: '#fff',
        animationEasingUpdate: "bounceIn",
        series: [
          {
            type: "graph",
            layout: "force",
            force: {
              repulsion: repulsion,
              edgeLength: 10,
            },

            // 是否开启鼠标缩放和平移漫游
            roam: false,
            label: {show: true,
            formatter: function (param) {
                return (
                  param.name+
                  "\n" +
                  ((100 * param.value) / that.num).toFixed(1) +
                  "%"
                );
              },
          position: "inside",
          color: "white",
          fontWeight: "bold",
          fontSize: 10, },
            data: bubbleData,
          },
        ],
      };
      bubbleChart.setOption(bubbleOptions);
    },
  },
};
</script>

<style scoped lang="scss">
#occupation-distribution {
  margin: 0 auto;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/OccupationDistribution.vue